import {createRouter,createWebHistory } from 'vue-router'

const Home  = () => import('../components/Home.vue')
const About  = () => import('../components/About.vue')
const Contact  = () => import('../components/Contact.vue')
const Problem  = () => import('../components/Problem.vue')

const createhistory = createWebHistory()
const router = createRouter({
  history: createhistory,
  routes: [
    {
      path: '/',
	  name:'home',
      component: Home
    },
	{
	  path: '/about',
	  name:'about',
	  component: About
	},
	{
		name:'contact',
	  path: '/contact',
	  component: Contact
	},
	{
		name:'problem',
		path: '/problem',
		component: Problem
	},
  ]
})
export default router
